export const setCookie = (key, value, expiration=setCookieExpiration(), path="/") => {
    document.cookie = `${key}=${value}; expires=${expiration.toUTCString()}; path=${path}`;
}

export const getCookie = (name) => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(`${name}=`)) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
}

export const setCookieExpiration = (date) => {
    return new Date(date || '9999-12-31T23:59:59');
}